import {
  Component,
  Event,
  EventEmitter,
  forceUpdate,
  getAssetPath,
  h,
  Host,
  Prop,
  State,
} from '@stencil/core';

import { GRECAPTCHA_SITEKEY } from '@web-components/constants';

import wcShared from '@web-components/shared';

import { getDriveFields } from './product-fields/kdrive/fields';
import { getPublicCloudFields } from './product-fields/public-cloud/fields';
import { getSwissBackupFields } from './product-fields/swiss-backup/fields';

import { SwissBackupStorage } from '../../../../utils/enum';
import helpdeskCommon from '../../../../utils/HelpdeskCommon.class';
import { InitStore } from '../../../../utils/Stores/init-store';
import { SectionStore } from '../../../../utils/Stores/section-store';
import { Store } from '../../../../utils/Stores/store';

@Component({
  tag: 'contact-mail-module',
  styleUrl: 'contact-mail-module.scss',
  shadow: true,
})
export class ModuleContactMail {
  private body: FormData = new FormData();
  private countFile = 0;
  private dataFiles: File[];
  private serviceList = [
    {
      label: wcShared?.translate('Service technique'),
      value: 'tech',
    },
    {
      label: wcShared?.translate('Service administratif'),
      value: 'admin',
    },
    {
      label: wcShared?.translate('Service commercial'),
      value: 'comm',
    },
    {
      label: wcShared?.translate('Entertainment'),
      value: 'entertainment',
    },
  ];
  private subProducts: IWCInitServiceSubCategoriesType[] = [];
  private inputFile: HTMLInputElement;

  @State() data: IWCTicket;
  @State() checkEmptyField = false;
  @State() dragOverFiles = false;
  @State() files: File[] = [];
  @State() loadingSending = false;
  @State() sendButton = true;
  @State() arrayError = [];
  @State() warningCheckJelastic = false;

  @Prop() readonly reload: boolean;

  @Event() sectionChangeEvent: EventEmitter<IWCContextClose[]>;

  componentWillLoad(): void {
    Store?.set('messageData', {
      ...Store?.get('messageData'),
      lang: wcShared?.store?.utils?.getLang(),
    });

    this.checkSubCategories();
    this.initEmail();
  }

  componentDidLoad() {
    // POST Statistic
    wcShared?.httpCall('PUT', '/api/components/chatbot/contact-type', { contact_type: 'mail' });

    // GOogle Recaptcha script injection
    if (!Boolean(InitStore?.get('init')?.user?.id)) {
      const script = document.createElement('script');
      script.src = 'https://google.com/recaptcha/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        const setIntevalLoaded = setInterval(() => {
          if (window['grecaptcha']?.render) {
            try {
              window['grecaptcha']?.render('recaptcha', {
                sitekey: GRECAPTCHA_SITEKEY,
                theme: wcShared?.store?.theme,
                callback: this.getTokenRecaptcha.bind(this),
              });
              clearInterval(setIntevalLoaded);
            } catch (err) {
              console.warn('recaptcha already loaded', err);
            }
          }
        }, 100);
      };
      document.body.appendChild(script);
    }
  }

  private reloadApp() {
    forceUpdate(this);
  }

  private initEmail(): void {
    if (Boolean(InitStore?.get('init')?.user?.email)) {
      Store?.set('messageData', {
        ...Store?.get('messageData'),
        email: InitStore?.get('init')?.user?.email,
      });
    }
  }

  private getTokenRecaptcha(token) {
    Store?.set('g_recaptcha_response', token);
    this.checkFields();
  }

  private changeData(event: Event, value: string) {
    const eventTarget = event.target as HTMLInputElement;
    switch (value) {
      case 'service':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          contact_type: eventTarget.value,
          service_slug: null,
        });
        break;

      case 'product':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          service_slug: eventTarget.value,
          // sub_category: null,
          priority:
            Store?.get('messageData')?.service_slug === 'jelastic' &&
            Store?.get('messageData')?.contact_type === 'tech'
              ? null
              : false,
        });
        break;

      // case 'subproduct':
      //   Store?.set('messageData', {
      //     ...Store?.get('messageData'),
      //     sub_category: eventTarget.value,
      //   });
      //   break;

      case 'subject':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          subject: eventTarget.value,
        });
        break;
      case 'public_cloud_region':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          public_cloud_region: eventTarget.value,
        });
        break;
      case 'public_cloud_service':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          public_cloud_service: eventTarget.value,
        });
        break;
      case 'public_cloud_service_info':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          public_cloud_service_info: eventTarget.value,
        });
        break;
      case 'description':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          description: eventTarget.value,
        });
        break;
      case 'partner_account':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          partner_account: eventTarget.value,
        });
        break;
      case 'priority':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          priority: eventTarget.value,
        });
        break;
      case 'email':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          email: eventTarget.value,
        });
        break;
      case 'drive_os':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          drive_os: eventTarget.value,
        });
        break;
      case 'drive_app_version':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          drive_app_version: eventTarget.value,
        });
        break;
      case 'public_cloud_product':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          public_cloud_product: eventTarget.value,
          public_cloud_project: null,
        });
        break;
      case 'public_cloud_project':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          public_cloud_project: eventTarget.value,
        });
        break;
      case 'swiss_backup_product':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          swiss_backup_product: eventTarget.value,
        });
        break;
      case 'swiss_backup_slot_cloud':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          swiss_backup_slot_cloud: eventTarget.value,
        });
        break;
      case 'swiss_backup_acronis_device':
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          swiss_backup_acronis_device: eventTarget.value,
        });
        break;
      case SwissBackupStorage.acronis:
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          swiss_backup_storage: value,
        });
        break;
      case SwissBackupStorage.cloud:
        Store?.set('messageData', {
          ...Store?.get('messageData'),
          swiss_backup_storage: value,
        });
        break;
      case 'warning':
        this.warningCheckJelastic = eventTarget.checked;
        break;
    }

    this.checkSubCategories();

    this.checkFields(true);
    forceUpdate(this);
  }

  private checkSubCategories(): void {
    const subCategoriesAll = InitStore?.get('init')?.environment?.services?.find(
      (service) => service.slug === Store?.get('messageData')?.service_slug,
    )?.sub_categories;

    this.subProducts =
      (Store?.get('messageData')?.contact_type === 'tech'
        ? subCategoriesAll?.technical
        : subCategoriesAll?.administrative) ?? [];
  }

  private addFile(event) {
    event.preventDefault();
    this.dragOverFiles = false;
    this.inputFile.click();
  }

  private formatFiles(e) {
    e.preventDefault();
    this.dataFiles = e.dataTransfer || e.target.files;
    this.dataFiles = this.dataFiles['files'] || this.dataFiles;

    Object.keys(this.dataFiles).forEach((id) => {
      if (this.dataFiles[id].size <= 50000000) {
        const exist = this.files.find(
          (item) => item.name === this.dataFiles[id].name && item.size === this.dataFiles[id].size,
        );
        if (!Boolean(exist)) {
          this.countFile++;
          this.files?.push(this.dataFiles[id]);
        }
      } else {
        this.arrayError?.push(this.dataFiles[id]);
        setTimeout(() => {
          this.arrayError.shift();
          forceUpdate(this);
        }, 5000);
      }
    });

    this.inputFile.value = '';

    this.reloadApp();
  }

  private getFilesTypeAccepted(): string {
    return Store?.get('messageData')?.contact_type === 'tech'
      ? 'image/*, .pdf, .docx, .exe, .dmg, .txt, .bin, .config'
      : 'image/*, .pdf, .docx, .odt, .pages, .numbers, .keynote';
  }

  private getProjectFields() {
    if (
      Store?.get('messageData')?.contact_type === 'tech' &&
      Boolean(InitStore?.get('init')?.user?.id)
    ) {
      switch (Store?.get('messageData')?.service_slug) {
        case 'drive':
          return getDriveFields(this.checkEmptyField, this.changeData.bind(this));
        case 'swiss_backup':
          if (InitStore?.get('init')?.environment?.swiss_backup.length > 0) {
            return getSwissBackupFields(this.checkEmptyField, this.changeData.bind(this));
          }
          break;
        case 'public_cloud':
          if (InitStore?.get('init')?.environment?.public_cloud.length > 0) {
            return getPublicCloudFields(this.checkEmptyField, this.changeData.bind(this));
          }
          break;
      }
    }
  }

  private checkFields(send = false) {
    let verif = true;
    Object.keys(Store?.get('messageData')).forEach((key) => {
      if (
        Store?.get('messageData')[key] === null ||
        Store?.get('messageData')[key] === undefined ||
        Store?.get('messageData')[key] === ''
      ) {
        if (
          Boolean(Store?.get('messageData')?.contact_type === 'tech') &&
          Boolean(InitStore?.get('init')?.user?.id)
        ) {
          switch (Store?.get('messageData')?.service_slug) {
            case 'drive':
              if (['drive_os', 'drive_app_version'].includes(key)) verif = false;
              break;
            case 'swiss_backup':
              if (InitStore?.get('init')?.environment?.swiss_backup.length > 0) {
                if (['swiss_backup_product', 'swiss_backup_storage'].includes(key)) verif = false;
              }
              break;
            case 'public_cloud':
              if (InitStore?.get('init')?.environment?.public_cloud.length > 0) {
                if ('public_cloud_product' === key) verif = false;
                if (
                  'public_cloud_project' === key &&
                  InitStore?.get('init')?.environment?.public_cloud.find(
                    (product: IWCPublicCloudEnvironment) =>
                      product.name === Store?.get('messageData')?.public_cloud_product,
                  )?.projects?.length > 0
                ) {
                  verif = false;
                }
              }
              break;
          }
        }

        if (InitStore?.get('init')?.user?.account?.is_partner && key === 'partner_account') {
          verif = false;
        }

        // Check if user is not connected && he hasn't fill this email
        if (
          key === 'email' &&
          !Boolean(InitStore?.get('init')?.user?.email) &&
          !this.validateEmail(Store?.get('messageData').email)
        ) {
          verif = false;
        }

        if (['subject', 'description', 'contact_type', 'service_slug'].includes(key)) {
          verif = false;
        }

        // if (key === 'sub_category') {
        //   if (
        //     Store?.get('messageData')?.contact_type !== 'comm' &&
        //     this.subProducts.length
        //   ) {
        //     verif = false;
        //   }
        // } else {
        //   verif = false;
        // }
      }
    });

    if (verif && !Boolean(InitStore?.get('init')?.user?.id)) {
      verif = !!Store?.get('g_recaptcha_response');
    }

    if (send) {
      this.sendButton = !verif;
    } else {
      this.sendButton = !verif;
      this.checkEmptyField = !verif;
    }
    return verif;
  }

  private handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  }

  private send() {
    this.reloadApp();
    if (!this.checkFields()) {
      return;
    }

    this.loadingSending = true;
    wcShared?.store?.loaderStart('loadingSending');

    if (this.countFile > 0) {
      this.body.append('number_file', String(this.countFile));
    }

    this.files.forEach((file, index) => {
      this.body.append(`file_${index + 1}`, file);
    });

    Object.keys(Store?.get('messageData')).forEach((item) => {
      this.body.append(item, Store?.get('messageData')[item]);
    });

    if (!Boolean(InitStore?.get('init')?.user?.id)) {
      this.body.append('g-recaptcha-response', Store?.get('g_recaptcha_response'));
    }

    // Debug use only on back
    this.body.append('debug', JSON.stringify(Store?.get('messageData')));

    let url = `/api/components/support/contact?lang=${wcShared?.store?.getLang()}`;
    url += helpdeskCommon.urlFormatFaq();

    wcShared
      ?.httpCall('POST', url, this.body, false, true)
      .then(this.handleErrors)
      .then((res) => {
        Store?.set('contactCode', res?.data?.mask);
        this.sectionChangeEvent.emit(['contact_mail_success']);
        wcShared?.store?.loaderStop('loadingSending').then(() => (this.loadingSending = false));
      })
      .catch(() => {
        this.sectionChangeEvent.emit(['contact_mail_error']);
        wcShared?.store?.loaderStop('loadingSending').then(() => (this.loadingSending = false));
      });
  }

  private getMimeType(file: File) {
    if (file.type.includes('application/pdf')) {
      return 'pdf';
    } else if (file.type.includes('text/plain')) {
      return 'text';
    } else if (file.type.includes('image/')) {
      return 'image';
    } else {
      return 'default';
    }
  }

  private deleteFile(index: number) {
    this.files.splice(index, 1);
    this.countFile--;
    this.reloadApp();
  }

  private validateEmail(email: string) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  render() {
    if (this.loadingSending) {
      return <module-loader-component />;
    } else {
      return (
        <Host>
          <div
            class={{
              'support-ik': true,
              'support-ik--full': Store?.get('is_full'),
              hide: !SectionStore?.get('section')?.contact_mail,
            }}
          >
            <img
              src={getAssetPath('./../assets/rounded-icons/icon-headset-white-bg.svg')}
              alt="Support Infomaniak"
            />
            <span>{wcShared?.translate('Support infomaniak')}</span>
          </div>
          <div
            class={{
              'mail-product': true,
              hide:
                !SectionStore?.get('section')?.contact_mail ||
                SectionStore?.get('section')?.contact_mail_success ||
                SectionStore?.get('section')?.contact_mail_error,
              'mail-product--full': Store?.get('is_full'),
              'mail-product--scroll': Store?.get('hasScroll') && Store?.get('is_full'),
            }}
          >
            <div class="ticket-title">{wcShared?.translate('Nouveau ticket')}</div>
            <div class="first-row">
              {/* Partner accounts */}
              <select
                class={{
                  'select-service': true,
                  'no-margin-bottom':
                    Store?.get('messageData')?.partner_account === null && this.checkEmptyField,
                  hide: !InitStore?.get('init')?.user?.account?.is_partner,
                }}
                disabled={Store?.get('contactEventData')?.partner_account?.disabled}
                onChange={(event) => this.changeData(event, 'partner_account')}
              >
                <option
                  value=""
                  selected
                  disabled
                  hidden
                >
                  {wcShared?.translate("Selectionner l'organisation")}
                </option>
                <option
                  selected={
                    InitStore?.get('init')?.user?.account?.id ===
                    Store?.get('messageData')?.partner_account
                  }
                  value={InitStore?.get('init')?.user?.account?.id}
                >
                  {InitStore?.get('init')?.user?.account?.organization_name}
                </option>
                {InitStore?.get('init')
                  ?.accounts?.filter(
                    (item) => item.id !== InitStore?.get('init')?.user?.account?.id,
                  )
                  .map((service) => {
                    return (
                      <option
                        selected={service?.name === Store?.get('messageData')?.partner_account}
                        value={service?.id}
                      >
                        {service?.name}
                      </option>
                    );
                  })}
              </select>
              <span
                class={{
                  'required-field': true,
                  hide:
                    !InitStore?.get('init')?.user?.account?.is_partner ||
                    Store?.get('messageData')?.partner_account !== null ||
                    !this.checkEmptyField,
                }}
              >
                {wcShared?.translate('*Champ obligatoire')}
              </span>

              {/* Service */}
              <select
                class={{
                  'select-service': true,
                  'no-margin-bottom':
                    Store?.get('messageData')?.contact_type === null && this.checkEmptyField,
                }}
                disabled={
                  (Store?.get('messageData')?.contact_type && !Store?.get('isFromLanding')) ||
                  Store?.get('contactEventData')?.contact_type?.disabled
                }
                onChange={(event) => this.changeData(event, 'service')}
              >
                <option
                  value=""
                  selected
                  disabled
                  hidden
                >
                  {wcShared?.translate('Mon probleme concerne')}
                </option>
                {this.serviceList?.map((service) => {
                  return (
                    <option
                      selected={service?.value === Store?.get('messageData')?.contact_type}
                      value={service?.value}
                    >
                      {service?.label}
                    </option>
                  );
                })}
              </select>
              <span
                class={{
                  'required-field': true,
                  hide: Store?.get('messageData')?.contact_type !== null || !this.checkEmptyField,
                }}
              >
                {wcShared?.translate('*Champ obligatoire')}
              </span>

              {/* Product */}
              <select
                class={{
                  'select-service': true,
                  'no-margin-bottom':
                    Store?.get('messageData')?.service_slug === null && this.checkEmptyField,
                  'margin-right-0':
                    !['admin', 'tech'].includes(Store?.get('messageData')?.contact_type) ||
                    Store?.get('messageData')?.service_slug === null ||
                    this.subProducts.length === 0,
                }}
                disabled={Store?.get('contactEventData')?.service_slug?.disabled}
                onChange={(event) => this.changeData(event, 'product')}
              >
                <option
                  value=""
                  selected={null === Store?.get('messageData')?.service_slug}
                  disabled
                  hidden
                >
                  {wcShared?.translate('Selectionnez un produit')}
                </option>
                {InitStore?.get('init')
                  ?.environment?.services.filter((product: IWCInitService) => {
                    if (Store?.get('messageData')?.contact_type) {
                      return product.tags.includes(Store?.get('messageData')?.contact_type);
                    }
                    Store?.set('messageData', {
                      ...Store?.get('messageData'),
                      service_slug: null,
                    });
                    return product;
                  })
                  ?.map((product) => {
                    return (
                      <option
                        selected={product.slug === Store?.get('messageData')?.service_slug}
                        value={product?.slug}
                      >
                        {product?.name}
                      </option>
                    );
                  })}
              </select>
              <span
                class={{
                  'required-field': true,
                  hide: Store?.get('messageData')?.service_slug !== null || !this.checkEmptyField,
                }}
              >
                {wcShared?.translate('*Champ obligatoire')}
              </span>

              {/* Sub Product */}
              {/* <select
              class={{
                "select-service select-sub-service": true,
                'no-margin-bottom': Store?.get('messageData')?.sub_category === null && this.checkEmptyField,
                'hide': !Store?.get('messageData')?.service_slug ||
                  Store?.get('messageData')?.contact_type === 'comm' ||
                  this.subProducts.length === 0
              }}
              disabled={Store?.get('contactEventData')?.sub_category?.disabled}
              onChange={(event) => this.changeData(event, 'subproduct')}>
              <option value="" selected disabled hidden>{wcShared?.translate('Selectionnez un sous produit')}</option>
              {
                this.subProducts.map(subProduct => {
                  return <option
                    selected={
                      subProduct.slug === Store?.get('messageData')?.sub_category
                    }
                    value={subProduct.slug}>
                    {subProduct.name}
                  </option>
                })
              }
            </select>
            <span class={{
              "required-field": true,
              'hide': Store?.get('messageData')?.sub_category !== null ||
                this.subProducts.length === 0 ||
                Store?.get('messageData')?.contact_type === 'comm'
            }}>{wcShared?.translate('*Champ obligatoire')}</span> */}
            </div>

            {/* Email (only for disconneted user) */}
            <input
              type="email"
              onKeyPress={(e) => {
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
              onKeyUp={(e) => {
                e.stopPropagation();
              }}
              class={{
                'no-margin-bottom':
                  (Store?.get('messageData')?.email === null ||
                    Store?.get('messageData')?.email === '' ||
                    !this.validateEmail(Store?.get('messageData')?.email)) &&
                  this.checkEmptyField,
                hide: Boolean(InitStore?.get('init')?.user?.email),
              }}
              placeholder={wcShared?.translate('Email') + '*'}
              value={Store?.get('messageData')?.email}
              onInput={(event) => this.changeData(event, 'email')}
              required
            />
            <span
              class={{
                'required-field': true,
                hide:
                  Boolean(InitStore?.get('init')?.user?.email) ||
                  (Store?.get('messageData')?.email !== null &&
                    Store?.get('messageData')?.email !== '' &&
                    this.validateEmail(Store?.get('messageData')?.email)) ||
                  !this.checkEmptyField,
              }}
            >
              {wcShared?.translate('*Champ obligatoire')}
            </span>

            {/* Subject */}
            <input
              type="text"
              onKeyPress={(e) => {
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
              onKeyUp={(e) => {
                e.stopPropagation();
              }}
              class={{
                'input-subject': true,
                'no-margin-bottom':
                  (Store?.get('messageData')?.subject === null ||
                    Store?.get('messageData')?.subject === '') &&
                  this.checkEmptyField,
                'not-last-input': Store?.get('messageData')?.service_slug === 'drive',
              }}
              disabled={
                Store?.get('contactEventData')?.subject?.disabled &&
                Store?.get('messageData')?.subject
              }
              placeholder={
                Store?.get('contactEventData')?.subject?.placeholder
                  ? Store?.get('contactEventData')?.subject?.placeholder
                  : wcShared?.translate('Sujet')
              }
              value={Store?.get('messageData')?.subject}
              maxlength="70"
              onInput={(event) => this.changeData(event, 'subject')}
              required
            />
            <span
              class={{
                'required-field': true,
                hide:
                  (Store?.get('messageData')?.subject !== null &&
                    Store?.get('messageData')?.subject !== '') ||
                  !this.checkEmptyField,
              }}
            >
              {wcShared?.translate('*Champ obligatoire')}
            </span>

            {/* Specific project fields */}
            {this.getProjectFields()}

            {/* Alert Need More Information */}
            <div class="need-information margin-top-50">
              <div class="need-information__image">
                <img
                  src={getAssetPath('./../assets/icons/light-bulb-shine.svg')}
                  alt={wcShared.translate('Ampoule')}
                />
              </div>
              <div class="need-information__text">
                {wcShared.translate(
                  "Afin que nous puissions vous aider efficacement, merci de nous transmettre le maximum de details concernant votre probleme (etapes effectuees pour reproduire le probleme, captures d'ecran, erreurs, etc.).",
                )}
                {Store?.get('messageData')?.service_slug === 'drive' && (
                  <a
                    href="https://www.infomaniak.com/fr/support/faq/2580/version-de-lapplication-kdrive-macos-windows-linux"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {' '}
                    {wcShared.translate('En savoir plus')}
                  </a>
                )}
              </div>
            </div>

            {/* Description */}
            <textarea
              onKeyPress={(e) => {
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
              onKeyUp={(e) => {
                e.stopPropagation();
              }}
              class={{
                'no-margin-bottom':
                  (Store?.get('messageData')?.description === null ||
                    Store?.get('messageData')?.description == '') &&
                  this.checkEmptyField,
                'not-last-input': Store?.get('messageData')?.service_slug === 'drive',
              }}
              value={Store?.get('messageData')?.description}
              disabled={Store?.get('contactEventData')?.description?.disabled}
              onInput={(e) => this.changeData(e, 'description')}
              placeholder={
                Store?.get('contactEventData')?.description?.placeholder
                  ? Store?.get('contactEventData')?.description?.placeholder
                  : wcShared.translate('Description')
              }
            ></textarea>
            <span
              class={{
                'required-field': true,
                hide:
                  (Store?.get('messageData')?.description !== null &&
                    Store?.get('messageData')?.description !== '') ||
                  !this.checkEmptyField,
              }}
            >
              {wcShared?.translate('*Champ obligatoire')}
            </span>

            {/* Upload Files */}
            <div class={{ 'mail-product-files': true }}>
              <div class="mail-product-files__title">{wcShared?.translate('Fichiers')}</div>
              <div class="mail-product-files__description">
                {wcShared?.translate("Captures d'ecran ou autres (50 Mo maximum)")}
              </div>
              <div
                class={{
                  'mail-product-files__files': true,
                  'mail-product-files__files--hover': this.dragOverFiles,
                }}
                onDragOver={(event) => {
                  event.preventDefault();
                  this.dragOverFiles = true;
                }}
                onDragLeave={() => (this.dragOverFiles = false)}
                onDrop={(event) => {
                  this.dragOverFiles = false;
                  this.formatFiles(event);
                }}
              >
                {Boolean(Object.keys(this.files)[0]) ? (
                  <div class="file-container">
                    {[
                      this.files.map((file, index) => {
                        return (
                          <div class="file">
                            <div
                              class="file__close"
                              onClick={() => this.deleteFile(index)}
                            >
                              <img
                                src={getAssetPath('./../assets/icons/white-cross.svg')}
                                alt={wcShared.translate('Supprimer')}
                              />
                            </div>
                            <img
                              src={getAssetPath(
                                `./../assets/icons/mimetype/${this.getMimeType(file)}.svg`,
                              )}
                              alt={wcShared.translate('Fichier')}
                            />
                            <div class="tooltip">
                              <span class={{ tooltiptext: true }}>{file.name}</span>
                              <div class="file__title">{file.name}</div>
                            </div>
                          </div>
                        );
                      }),
                      <div
                        class="upload"
                        onClick={(event) => this.addFile(event)}
                      >
                        +
                      </div>,
                    ]}
                  </div>
                ) : (
                  <div class="file-container">
                    <img
                      src={getAssetPath('./../assets/icons/attachment_2.svg')}
                      alt={wcShared.translate('Icon attachment')}
                    />
                    <div>
                      <a
                        href="#"
                        onClick={(event) => this.addFile(event)}
                      >
                        {wcShared?.translate('Ajouter un fichier')}
                      </a>{' '}
                      {wcShared?.translate('ou faites glisser les fichiers ici')}
                    </div>
                  </div>
                )}
              </div>
              {/* Error Files */}
              <div class={{ error: true, hide: this.arrayError.length === 0 }}>
                {this.arrayError.map((file) => {
                  return (
                    <div
                      class="error-file"
                      innerHTML={wcShared?.translate(
                        '<strong>$name$</strong> est trop volumineux',
                        {
                          name: wcShared.store?.pipes?.escapeHtml(file.name),
                        },
                      )}
                    ></div>
                  );
                })}
              </div>
              <div class="mail-product-files__info">
                <img
                  src={getAssetPath('./../assets/icons/information-circle.svg')}
                  alt={wcShared.translate('Icon information')}
                />
                <p>
                  {wcShared?.translate(
                    'Nos techniciens auront acces a la conversation afin de vous aider plus facilement',
                  )}
                  .
                </p>
              </div>
            </div>

            {/* Action */}
            <div class="mail-product-action">
              {/* Recaptcha */}
              {!Boolean(InitStore?.get('init')?.user?.id) ? (
                <div class="g-recaptcha">
                  <slot name="recaptcha-slot-4" />
                </div>
              ) : (
                ''
              )}
              <button
                type="button"
                onClick={() => this.send()}
                class={{ disabled: this.sendButton }}
              >
                {wcShared?.translate('Envoyer ma demande')}
              </button>
            </div>
            <input
              class="hide"
              ref={(el) => {
                this.inputFile = el as HTMLInputElement;
              }}
              onChange={(event) => this.formatFiles(event)}
              type="file"
              accept={this.getFilesTypeAccepted()}
              multiple
              hidden
            />
          </div>
          <div class="ending-padding"></div>
          <div
            class={{
              'mail-product--success': true,
              hide: !SectionStore?.get('section')?.contact_mail_success,
            }}
          >
            <contact-mail-success-module></contact-mail-success-module>
          </div>
          <div
            class={{
              'mail-product--error': true,
              hide: !SectionStore?.get('section')?.contact_mail_error,
            }}
          >
            <contact-mail-error-module></contact-mail-error-module>
          </div>
        </Host>
      );
    }
  }
}
